import { useMemo } from 'react';
import { useGetUserCards as useGetUserCardsQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

export const useGetCards = (props?: { canceled?: boolean }) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const {
    data: cardsData,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetUserCardsQuery({
    enabled: !!id,
    userId: id ?? 0,
  });

  const filteredCards = useMemo(() => {
    if (props?.canceled) {
      return cardsData || [];
    }
    return cardsData?.filter((card) => card.status !== 'cancel') || [];
  }, [cardsData, props?.canceled]);

  /* Return */
  return {
    isLoading,
    cardsData: filteredCards,
    isError,
    error,
    refetch,
  };
};
